import React from 'react';
import ManageGSMForm from '../Forms/manage_gsm_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
    { label: 'GSM Value', field: 'GSMValue' },
    { label: 'GSM Type', field: 'GSMType' },
];

function Manage_gsm() {
    return (
        <ManageDataPage
            title="Manage GSM"
            endpoint="get_manage_gsm_table"
            columns={COLUMNS}
            editable={false}
            FormComponent={ManageGSMForm}
            searchPlaceholder="Search name, GSM, type..."
        />
    );
}

export default Manage_gsm;
